var trackEvents = {
	carousel_callout_type1_increment: false
};




/* Vue mini components */
$(".carousel_callout_type1").each(function(){
	var singleID = $(this).attr("id");
	new Vue({
		el: '#'+singleID,
		data: {
			carousel_callout_type1:{
				curr: 1,
				total: $(this).find(".bg-single").length
			},
			timerLoop:null,
			autoplaying:true,
			timerMax:240,
			timerInc:0,
			allowTick:true
		},
		computed: {
			activePerc: function () {
				if(!this.autoplaying){
					return 0;
				}
				return (this.timerInc/this.timerMax)*100;
			}
		},
		methods:{
			carousel_callout_type1_increment:function(){
				let tempVal = this.carousel_callout_type1.curr+1;
				if(tempVal > this.carousel_callout_type1.total){
					tempVal = 1;
				}
				this.carousel_callout_type1.curr = tempVal;
			},
			stopTimer:function(){
				// clearInterval(this.timerLoop);
				this.autoplaying = false;
			},
			setSlide:function(newSlide){
				this.carousel_callout_type1.curr = newSlide;
				this.stopTimer();
			},
			startTimer:function() {
				this.requestTick();
			},
			requestTick:function() {
				var scopeThis = this;
				if(!scopeThis.ticking) {
					requestAnimationFrame(scopeThis.update);
					scopeThis.ticking = true;
				}
			},
			update:function() {
				var scopeThis = this;
				if(this.autoplaying === true && this.allowTick){
					this.timerInc++;
					// console.log(scopeThis.timerInc);
					if(this.timerInc >= this.timerMax){
						this.timerInc = 0;
						this.carousel_callout_type1_increment();
					}
				}

				requestAnimationFrame(scopeThis.requestTick);
				scopeThis.ticking = false;
			}
		},
		mounted(){
			var scopeThis = this;
			// this.timerLoop = setInterval(this.carousel_callout_type1_increment,5000);
			trackEvents.carousel_callout_type1_increment = true;
			// this.startTimer();
			inView('#'+singleID)
				.once('enter', el => {
					requestAnimationFrame(scopeThis.requestTick);
				}
			);

			inView('#'+singleID + ' .threshold-iv')
				.on('enter', el => {
					scopeThis.allowTick = true;
				}).on('exit', el => {
					scopeThis.allowTick = false;
				});
			
		}
	});
});

$(".carousel_journal_landing").each(function(){
	var singleID = $(this).attr("id");
	new Vue({
		el: '#'+singleID,
		data: {
			carousel_journal_landing:{
				curr: 1,
				total: $(this).find(".bg-single").length
			},
			timerLoop:null,
			autoplaying:true,
			timerMax:240,
			timerInc:0,
			allowTick:true
		},
		computed: {
			activePerc: function () {
				if(!this.autoplaying){
					return 0;
				}
				return (this.timerInc/this.timerMax)*100;
			}
		},
		methods:{
			carousel_journal_landing_increment:function(){
				let tempVal = this.carousel_journal_landing.curr+1;
				if(tempVal > this.carousel_journal_landing.total){
					tempVal = 1;
				}
				this.carousel_journal_landing.curr = tempVal;
			},
			stopTimer:function(){
				// clearInterval(this.timerLoop);
				this.autoplaying = false;
			},
			setSlide:function(newSlide){
				this.carousel_journal_landing.curr = newSlide;
				this.stopTimer();
			},
			startTimer:function() {
				this.requestTick();
			},
			requestTick:function() {
				var scopeThis = this;
				if(!scopeThis.ticking) {
					requestAnimationFrame(scopeThis.update);
					scopeThis.ticking = true;
				}
			},
			update:function() {
				var scopeThis = this;
				if(this.autoplaying === true && this.allowTick){
					this.timerInc++;
					// console.log(scopeThis.timerInc);
					if(this.timerInc >= this.timerMax){
						this.timerInc = 0;
						this.carousel_journal_landing_increment();
					}
				}

				requestAnimationFrame(scopeThis.requestTick);
				scopeThis.ticking = false;
			}
		},
		mounted(){
			var scopeThis = this;
			// this.timerLoop = setInterval(this.carousel_journal_landing_increment,5000);
			trackEvents.carousel_journal_landing_increment = true;
			// this.startTimer();
			requestAnimationFrame(scopeThis.requestTick);

		}
	});
});
var projectApp = null;
$(".projects-app").each(function(){
	var singleID = $(this).attr("id");
	projectApp = new Vue({
		el: '#'+singleID,
		data: {
			carousel_journal_landing:{
				curr: 1,
				total: $(this).find(".bg-single").length
			},
			timerLoop:null,
			projectData:null,
			filterRegion:null,
			filterSector:null,
			filterStatus:null,
			projectView:null
		},
		computed: {
			// filteredItems: function () {
			// 	let outData = this.projectData;
			// 	if(this.filterSector){
			// 		outData = outData.filter(function(project){
			// 			return project.title.rendered.toLowerCase().includes('adelaide'.toLowerCase());
			// 		});
			// 	}

			// 	return outData;
			// 	// return this.projectData.filter(item => {
			// 	// 	return item.regions.toLowerCase().indexOf('australia') > -1
			// 	// })
			// 	// let filter = new RegExp(this.filterText, 'i')
			// 	// return this.games.filter(el => el.title.match(filter))
			// },
			filteredItems: function () {
				var scopeThis = this;
				if(this.projectData && this.projectData.length > 0){
					let outData = this.projectData;
					if(this.filterSector){
						outData = outData.filter(function(project){
							// return project.regions.includes('australia');
							if(project.sectors.length > 0){
								for(var i = 0; i < project.sectors.length; i++){
									if(project.sectors[i].slug.includes(scopeThis.filterSector)){
										return true;
									}
								}
								return false;
							}
						});
					}

					if(this.filterRegion){
						outData = outData.filter(function(project){
							// return project.regions.includes('australia');
							if(project.regions.length > 0){
								for(var i = 0; i < project.regions.length; i++){
									if(project.regions[i].slug.includes(scopeThis.filterRegion)){
										return true;
									}
								}
								return false;
							}
						});
					}


					if(this.filterStatus){
						outData = outData.filter(function(project){
							// return project.regions.includes('australia');
							if(project.pstatus.length > 0){
								for(var i = 0; i < project.pstatus.length; i++){
									if(project.pstatus[i].slug.includes(scopeThis.filterStatus)){
										return true;
									}
								}
								return false;
							}
						});
					}

					let newURL = '/projects/filter/';
					if(this.filterSector){
						newURL = newURL + this.filterSector + '/';
					} else {
						newURL = newURL + 'all/';
					}
					if(this.filterRegion){
						newURL = newURL + this.filterRegion + '/';
					} else {
						newURL = newURL + 'all/';
					}
					if(this.filterStatus){
						newURL = newURL + this.filterStatus + '/';
					} else {
						newURL = newURL + 'all/';
					}
					newURL = newURL.replace('/filter/all/all/all/','/');
					// console.log(newURL);
					var currURL = window.location.pathname;
					// console.log(newURL, currURL, this.projectView);
					if(newURL !== currURL && this.projectView === null){
						const state = { 'url': newURL };
						const title = '';
						const url = newURL;

						if(newURL === '/projects/'){
							$("#main").removeClass("has-project-filters");
						} else {
							$("#main").addClass("has-project-filters");
						}

						$( ".page-title-wrap.near-header" ).load( newURL + " h1#pagetitle" );

						history.pushState(state, title, url);
					} else if(currURL === '/projects/all/'){
						scopeThis
					}
					return outData;
				} else {
					return null;					
				}
			},
			activePerc: function () {
				if(!this.autoplaying){
					return 0;
				}
				return (this.timerInc/this.timerMax)*100;
			}
		},
		methods:{
			toggleStatus:function(newVal){
				this.projectView = null;
				if(this.filterStatus === newVal){
					this.filterStatus = null;
				} else {
					this.filterStatus = newVal;
				}
			},
			toggleSector:function(newVal){
				this.projectView = null;
				if(this.filterSector === newVal){
					this.filterSector = null;
				} else {
					this.filterSector = newVal;
				}
			},
			toggleRegion:function(newVal){
				this.projectView = null;
				if(this.filterRegion === newVal){
					this.filterRegion = null;
				} else {
					this.filterRegion = newVal;
				}
			},
			toggleView:function(whichView){
				this.filterRegion = null;
				this.filterSector = null;
				this.filterStatus = null;
				if(whichView === 'featured'){
					this.projectView = null;
					var currURL = window.location.pathname;
					if(currURL !== '/projects/'){
						const state = { 'url': '/projects/' };
						const title = '';
						const url = '/projects/';
						history.pushState(state, title, url);
					}
				} else if(whichView === 'all') {
					this.projectView = whichView;
					if(currURL !== '/projects/all/'){
						const state = { 'url': '/projects/all/' };
						const title = '';
						const url = '/projects/all/';
						history.pushState(state, title, url);
					}
				}
				$("#pagetitle").html('Projects');
			},
			sectorEnabled:function(testVal){
				if(this.filterRegion){
					if(this.filteredItems && this.filteredItems.length > 0){
						for(var i = 0; i < this.filteredItems.length; i++){
							if(this.filteredItems[i].sectors.length > 0){
								for(var j = 0; j < this.filteredItems[i].sectors.length; j++){
									if(this.filteredItems[i].sectors[j].slug.includes(testVal)){
										return false;
									}
								}
							}
						}
					}
				} else {
					return false;
				}
				return true;
			},
			regionEnabled:function(testVal){
				if(this.filterSector){
					if(this.filteredItems && this.filteredItems.length > 0){
						for(var i = 0; i < this.filteredItems.length; i++){
							if(this.filteredItems[i].regions.length > 0){
								for(var j = 0; j < this.filteredItems[i].regions.length; j++){
									if(this.filteredItems[i].regions[j].slug.includes(testVal)){
										return false;
									}
								}
							}
						}
					}
				} else {
					return false;
				}
				return true;
			},
			statusEnabled:function(testVal){
				if(this.filterRegion || this.filterSector){
					if(this.filteredItems && this.filteredItems.length > 0){
						for(var i = 0; i < this.filteredItems.length; i++){
							if(this.filteredItems[i].pstatus.length > 0){
								for(var j = 0; j < this.filteredItems[i].pstatus.length; j++){
									if(this.filteredItems[i].pstatus[j].slug.includes(testVal)){
										return false;
									}
								}
							}
						}
					}
				} else {
					return false;
				}
				return true;
			}
			// carousel_journal_landing_increment:function(){
			// 	let tempVal = this.carousel_journal_landing.curr+1;
			// 	if(tempVal > this.carousel_journal_landing.total){
			// 		tempVal = 1;
			// 	}
			// 	this.carousel_journal_landing.curr = tempVal;
			// }
		},
		created(){
			if(typeof(projData) !== "undefined"){
				this.projectData = projData;
			}
			if(typeof(initSector) !== "undefined" && initSector && initSector !== 'all'){
				this.filterSector = initSector;
			}
			if(typeof(initRegion) !== "undefined" && initRegion && initRegion !== 'all'){
				this.filterRegion = initRegion;
			}
			if(typeof(initStatus) !== "undefined" && initStatus && initStatus !== 'all'){
				this.filterStatus = initStatus;
			}
			if(typeof(initView) !== "undefined" && initView){
				this.projectView = initView;
			}

			// console.log(this.filterSector, this.filterRegion, this.filterStatus);
			// var scopeThis = this;
			// // this.timerLoop = setInterval(this.carousel_journal_landing_increment,5000);
			// trackEvents.carousel_journal_landing_increment = true;
			// // this.startTimer();
			// requestAnimationFrame(scopeThis.requestTick);

		}
	});
});

/* Vue mini components */
$(".carousel_feat_hero").each(function(){
	var singleID = $(this).attr("id");
	new Vue({
		el: '#'+singleID,
		data: {
			carousel_hero_feature:{
				curr: 1,
				total: $(this).find(".slide").length
			},
			timerLoop:null,
			radialTimer:null,
			autoplaying:true
		},
		methods:{
			carousel_hero_feature_increment:function(){
				let tempVal = this.carousel_hero_feature.curr+1;
				if(tempVal > this.carousel_hero_feature.total){
					tempVal = 1;
				}
				this.carousel_hero_feature.curr = tempVal;
			},
			stopTimer:function(){
				clearInterval(this.timerLoop);
				// clearInterval(this.radialTimer);
			},
			setSlide:function(newSlide){
				this.carousel_hero_feature.curr = newSlide;
				this.stopTimer();
				this.autoplaying = false;
			}
		},
		mounted(){
			var scopeThis = this;
			inView('#'+singleID)
				.once('enter', el => {
					scopeThis.timerLoop = setInterval(scopeThis.carousel_hero_feature_increment,5000);
				}
			);
			



			if($(".radial-icons-wrap").hasClass("radial-icons-wrap")){
				/* Begin Stroke outline animation */
				var radius = 7;
				var circumference = radius * 2 * Math.PI;
				var targetElIndex = 0;

				var targetEl = $(".radial-icons-wrap").eq(targetElIndex).find("circle")[0];
				targetEl.style.strokeDasharray = `${circumference} ${circumference}`;
				var percent = 0;

				scopeThis.radialTimer = setInterval(function(){
					if(scopeThis.autoplaying){
						percent = percent + 1;
						if(percent > 100){
							percent = 0;
							targetElIndex = targetElIndex + 1;
							if(targetElIndex >= scopeThis.carousel_hero_feature.total){ targetElIndex = 0; }
							var offset = circumference - 100 / 100 * circumference;
							targetEl.style.strokeDashoffset = offset;

							targetEl = $(".radial-icons-wrap").find("circle")[targetElIndex];
							// targetEl.style.strokeDasharray = `${circumference} ${circumference}`;
							targetEl.style.strokeDasharray = radius * 2 * Math.PI + ' ' + radius * 2 * Math.PI;
						}
						var percentBackward = 100 - percent;
						var offset = circumference - percentBackward / 100 * circumference;
						targetEl.style.strokeDashoffset = offset;
					}
				},50);
				/* End Stroke outline animation */
			}
		}
	});
});

$(".associated-people").each(function(){
	var singleID = $(this).attr("id");
	new Vue({
		el: '#'+singleID,
		data: {
			peoplepreview:null
		},
		methods:{
			
		},
		mounted(){
			// this.timerLoop = setInterval(this.carousel_callout_type1_increment,3000);
		}
	});
});

$(".wb-studio-block").each(function(){
	var singleID = $(this).attr("id");
	new Vue({
		el: '#'+singleID,
		data: {
			peoplepreview:null,
			studiopreview:null
		},
		methods:{
			activateStudio:function(newStudio){
				if(newStudio !== this.studiopreview){
					this.studiopreview = newStudio;
				} else {
					this.studiopreview = null;
				}
			}
		},
		mounted(){
			// this.timerLoop = setInterval(this.carousel_callout_type1_increment,3000);
		}
	});
});

$(".hor-overflow").each(function(){
	var scopeThis = $(this);
	var singleID = $(this).attr("id");
	if($(this).find('.ref-single').length > 2){
		var slider = new KeenSlider('#'+singleID, {
			slidesPerView: 1.3,
			spacing: 0,
			loop: true,
			duration:250,
			mode: "snap",
			slides:'.ref-single',
			breakpoints: {
				"(min-width: 769px)": {
					slidesPerView: 2.3,
					mode: "snap"
				},
				"(min-width: 1600px)": {
					slidesPerView: 3.1,
					mode: "snap"
				}
			},
			created: function(instance) {
				scopeThis.find(".carousel-nav--right").on("click",function(){
					instance.next();
				})
			},
		});
	} else {
		$(this).addClass("no-cycle");
	}
});


var allowTicking = true;
$(".wb-simple-gallery").each(function(){
	var singleID = $(this).attr("id");
	var scopeThisGal = $(this);
	var slideDetails = null;
	var sliderAutoplay = false;
	
	if($(this).hasClass("autoplay-speed1")){
		sliderAutoplay = 3000;
	} else if($(this).hasClass("autoplay-speed2")){
		sliderAutoplay = 5000;
	} else if($(this).hasClass("autoplay-speed3")){
		sliderAutoplay = 7000;
	}
	var interval = 0;

	inView('#'+singleID + ' .threshold-iv')
		.on('enter', el => {
			allowTicking = true;
		}).on('exit', el => {
			allowTicking = false;
		});
	function autoplay_simplegal(run) {
		clearInterval(interval);
		interval = setInterval(() => {
			if (run && slider && allowTicking) {
				slider.next();
			}
		}, sliderAutoplay);
	}
	var arrowTO = null;
	var slider = new KeenSlider('#'+singleID, {
		slidesPerView: 1,
		spacing: 0,
		loop: true,
		duration:250,
		mode: "snap",
		slides:'.simple-gal-slide',
		created: slider => {
			// console.log(slider.details())
			var parEl = scopeThisGal.closest('.simple-gallery');
			parEl.find(".arrow, .inv-nav").on("click",function(){
				scopeThisGal.addClass("dragging");
				clearTimeout(arrowTO);
				autoplay_simplegal(false);
				arrowTO = setTimeout(function(){
					scopeThisGal.removeClass("dragging");
				},250);
				if($(this).hasClass("arrow-e") || $(this).hasClass("inv-nav-e")){
					slider.next();
				} else {
					slider.prev();
				}
			});
			slideDetails = slider.details();

			document.onkeydown = function(e) {
				switch(e.which) {
					case 37: // left
					slider.prev();
					break;

					case 39: // right
					slider.next();
					break;

					default: return; // exit this handler for other keys
				}
			};
		},
		dragStart: () => {
			autoplay_simplegal(false);
			scopeThisGal.addClass("dragging");
		},
		dragEnd: () => {
			autoplay_simplegal(false);
			scopeThisGal.removeClass("dragging");
		},
		slideChanged:function(){
			if(slideDetails){
				var parEl = scopeThisGal.closest(".wb-simple-gallery");
				// console.log("setting to " + slider.details().relativeSlide);
				var newCnt = ((slider.details().relativeSlide)+1);
				if($(window).width() < 768){
					newCnt = Math.ceil(newCnt/2);
				}
				parEl.parent().find(".gallery-curr").html(newCnt);
				// console.log(slider.details().relativeSlide);
			} else {
				// console.log("No details found");
			}
		},
	});
	if(sliderAutoplay){
		inView('#'+singleID)
			.once('enter', el => {
				autoplay_simplegal(true);
			}
		);

	}
});

$(".mobile-gallery").each(function(){
	var singleID = $(this).attr("id");
	var interval = 0;
	function autoplay(run) {
		clearInterval(interval);
		interval = setInterval(() => {
			if (run && slider) {
				slider.next();
			}
		}, 5000);
	}
	var slidesPerView = 1;
	var isCentered = false;
	var dynSpacing = 0;
	if($(this).hasClass("hero-journal-landing-carousel")){
		slidesPerView = 1.1;
		isCentered = true;
		dynSpacing = 5;
	}
	var slider = new KeenSlider('#'+singleID, {
		slidesPerView: slidesPerView,
		spacing: dynSpacing,
		loop: true,
		duration:500,
		mode: "snap",
		centered: isCentered,
		slides:'.slide-single',
		dragStart: () => {
			autoplay(false);
		},
		dragEnd: () => {
			// autoplay(true);
		},
		slideChanged:function(){
			// console.log("slide start");
			$('#'+singleID).addClass("slide-change");
		},
		beforeChange:function(){
			// console.log("before start");
			$('#'+singleID).addClass("slide-change");
		},
		afterChange:function(){
			// console.log("after start");
			$('#'+singleID).removeClass("slide-change");
		}
	});
	autoplay(true);
});


$(".inline-book-slides").each(function(){
	var singleID = $(this).attr("id");
	var slideDetails = null;
	var scopeThisBook = $(this);
	var slider = new KeenSlider('#'+singleID, {
		slidesPerView: 1,
		spacing: 0,
		loop: true,
		mode: "snap",
		duration:250,
		autoHeight:false,
		slides:'.slidewrap',
		controls:true,
		breakpoints: {
			"(min-width: 768px)": {
				slidesPerView: 1,
				slides:'.slidewrap-dt',
				mode: "snap"
			}
		},
		created: slider => {
			// console.log(slider.details())
			var parEl = $(this).closest(".row-inline-book-gallery");
			parEl.find(".arrow").on("click",function(){
				if($(this).hasClass("arrow-e")){
					slider.next();
				} else {
					slider.prev();
				}
			});
			slideDetails = slider.details();
		},
		slideChanged:function(){
			if(slideDetails){
				var parEl = scopeThisBook.closest(".row-inline-book-gallery");
				// console.log("setting to " + slider.details().relativeSlide);
				var newCnt = ((slider.details().relativeSlide)+1);
				if($(window).width() < 768){
					newCnt = Math.ceil(newCnt/2);
				}
				parEl.find(".cnt-curr").html(newCnt);
				// console.log(slider.details().relativeSlide);
			} else {
				console.log("No details found");
			}
		},
		// beforeChange: slider => {
		// 	// console.log(slider.details())
		// 	// console.log(slider.details().relativeSlide);
		// },
		// afterChange: slider => {
		// 	// console.log(slider.details())
		// 	// console.log(slider.details().relativeSlide);
		// 	// console.log(slider.details().size);
		// }
	});
});

$(".js-wechat-link").on("click",function(e){
	e.preventDefault();
	$("footer .qr-code").toggleClass("wechat-vis");
})


$(".hovParent a").on({
	mouseenter: function() {
		$(this)
			.closest(".hovParent")
			.addClass("hovered");
	},
	mouseleave: function() {
		$(this)
			.closest(".hovParent")
			.removeClass("hovered");
	},
});

$(".menu-wrap-secondary .menu-headline a").on("click",function(e){
	if($(window).width() <= 767){
		e.preventDefault();
		if($(this).closest('.menu-wrap-secondary').hasClass('secondary-on')){
			window.location = $(this).attr("href");
		} else {
			$(this).closest('.menu-wrap-secondary').toggleClass("secondary-on");
		}
	}
});



// var scrollOffset = $(window).height();
// $(window).resize(function(){
// 	scrollOffset = $(window).height();
// });
var scrollOffset = 10;

var scrollTF = false;
var scrollMTF = false;

var lastScrollY = 0,
	lastScrollTop = 0,
	scrollPos = 0,
	delta = 50,
	ticking = false;
var navFixed = false;
function checkScrollPos(){

	if(scrollPos > 20){
		if(!scrollTF){
			scrollTF = true;
			$("#wbhead").addClass("scrolled");
		}
	} else {
		if(scrollTF){
			scrollTF = false;
			$("#wbhead").removeClass("scrolled");
		}
	}
	if(scrollPos > 48){
		if(!scrollMTF){
			scrollMTF = true;
			$("#wbhead, .mo-menu-toggle").addClass("scrolled-m");
		}
	} else {
		if(scrollMTF){
			scrollMTF = false;
			$("#wbhead, .mo-menu-toggle").removeClass("scrolled-m");
		}
	}

	if(scrollPos >= scrollOffset){
		if(!navFixed){
			navFixed = true;
			$("#wbhead").addClass("scrolled-in");
			$(".menu-pagetop,.stick-filter").addClass("on-bg");
		}
	} else {
		if(navFixed){
			navFixed = false;
			$("#wbhead").removeClass("scrolled-in");
			$(".menu-pagetop,.stick-filter").removeClass("on-bg");
		}
	}

	if(trackEvents.carousel_callout_type1_increment){

	}


	lastScrollTop = scrollPos;
}

function onScroll() {
	lastScrollY = window.scrollY;
	requestTick();
}

function requestTick() {
	if(!ticking) {
		requestAnimationFrame(update);
		ticking = true;
	}
}
function update() {
	scrollPos = lastScrollY;
	checkScrollPos();

	ticking = false;
}

window.addEventListener('scroll', onScroll, false);
onScroll();





// Temp
$(".row-filters button, .stick-filter button").on("click",function(){
	$(".panel-slide.project-filters").toggleClass("on");
});
$(".panel-slide .close").on("click",function(){
	$(this).closest(".panel-slide").removeClass("on");
});
$(".panel-close, .view-results").on("click",function(){
	$(".panel-slide.on").removeClass("on");
});


var menuTimer = null;
	$(".menu-pagetop .menu-toggle, .mo-menu-toggle").on("click",function(){
		$("body").addClass("has-ani");
		$("body").toggleClass("menu-on");
		$(".menu-scroll").scrollTop(0);
		clearTimeout(menuTimer);
		menuTimer = setTimeout(function(){
			$("body").removeClass("has-ani");
		},1000);
		setTimeout(function(){
			$(".nav-feature").not('.nav-init').each(function(){
				$(this).addClass("nav-init");
				var singleID = $(this).attr("id");
				// console.log(singleID);
				var slider = new KeenSlider('#'+singleID, {
					slidesPerView: 1.3,
					slides:'.nav-single',
					spacing: 16,
					loop: false,
					mode: "snap",
					duration:250,
					breakpoints: {
						"(min-width: 769px)": {
							slidesPerView: 3.1,
							mode: "snap"
						}
					}
				});
			});
		},50);
	});
	// $(".sg-false-row .menu-toggle, .menu-pagetop .menu-toggle").on("click",function(){
	// 	$(this).toggleClass("open");
	// 	$(this).closest('.menu-pagetop').toggleClass("on");
	// 	$(this).parent().parent().find(".menu-panel").toggleClass('on');
	// });
	$(".stroke-count button").on("click",function(){
		$(this).parent().find(".active").removeClass("active");
		$(this).addClass("active");
	});

	/* Video Buttons */
	$(".video-buttons button").on("click",function(){
		$(this).toggleClass("on");
		if($(this).hasClass("pause-toggle")){
			if($(this).hasClass("on")){
				$(this).closest(".video-wrap").find("video")[0].pause();
			} else {
				$(this).closest(".video-wrap").find("video")[0].play();
			}
		}
	});

	$(".group-w-link").each(function(){
		var firstLink = $(this).find('a').eq(0);
		if(firstLink){
			var linkURL = firstLink.attr("href");
			var linkText = firstLink.html();
			if(linkURL && linkURL !== ''){
				$(this).append('<a href="' + linkURL + '" class="overlink">' + linkText + '</a>');

				$(".group-w-link a").hover(function(){
					$(this).closest('.group-w-link').addClass("hovered");
				},function(){
					$(this).closest('.group-w-link').removeClass("hovered");
				});
			}
		}
	});


	/* More button */
	$(".expand-button").on("click",function(){
		$(this).closest(".expansion-wrap").toggleClass("visible");
	});
	
	function shuffle(array) {
		for (let i = array.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}
	function randImg(orient){
		var imgPool = [
			'/wp-content/uploads/2020/05/fpo-proj-1.jpg',
			'/wp-content/uploads/2020/05/fpo-proj-2.jpg',
			'/wp-content/uploads/2020/05/fpo-proj-3.jpg',
			'/wp-content/uploads/2020/05/fpo-sector-1.jpg',
			'/wp-content/uploads/2020/05/fpo-studio-1.jpg',
			'/wp-content/uploads/2020/05/fpo-vert-proj-1.jpg',
			'/wp-content/uploads/2020/05/fpo-vert-proj-2.jpg',
			'/wp-content/uploads/2020/05/fpo-vert-proj-3.jpg',
			'/wp-content/uploads/2020/05/fpo-vert-proj-4.jpg'
		];
		if(orient === 'vert'){
			imgPool = [
				'/wp-content/uploads/2020/05/fpo-vert-proj-1.jpg',
				'/wp-content/uploads/2020/05/fpo-vert-proj-2.jpg',
				'/wp-content/uploads/2020/05/fpo-vert-proj-3.jpg',
				'/wp-content/uploads/2020/05/fpo-vert-proj-4.jpg'
			];
		} else if(orient === 'hor'){
			imgPool = [
				'/wp-content/uploads/2020/05/fpo-proj-1.jpg',
				'/wp-content/uploads/2020/05/fpo-proj-2.jpg',
				'/wp-content/uploads/2020/05/fpo-proj-3.jpg',
				'/wp-content/uploads/2020/05/fpo-sector-1.jpg',
				'/wp-content/uploads/2020/05/fpo-studio-1.jpg'
			];
		}
		shuffle(imgPool);
		return imgPool[0];
	}

	inView.offset({
		top: 0,
		right: 0,
		bottom: 50,
		left: 0
	});
	inView('.iv')
		.on('enter', el => {
			el.classList.add("in-view");
		});


	// inView.threshold(0.5);
	// inView('.text-block-1').set({ threshold: 0.5 })
	// 	.on('enter', el => {
	// 		el.classList.add("threshold-in");
	// 	}).on('exit', el => {
	// 		el.classList.remove("threshold-in");
	// 	});
	// console.log(inView('.text-block-1').check());
	// $(".text-block-1").each(function(){
	// 	var localThis = $(this);
	// 	$(window).scroll(function(){
	// 		inView.test((localThis, ) => {
			    
	// 		});
	// 	});
		
	// });

	// inView('.threshold-iv')
	// 	.on('enter', el => {
	// 		$(el).closest('section').addClass("threshold-in");
	// 	}).on('exit', el => {
	// 		$(el).closest('section').removeClass("threshold-in");
	// 	});


	inView('.row-media .video-wrap').on('enter', el => {
			startVideo(el);
		}).on('exit', el => {
			stopVideo(el);
		});

	inView('.row-reference .video-wrap').on('enter', el => {
			startVideo(el);
		}).on('exit', el => {
			stopVideo(el);
		});

	inView('.row-reference-text-overlay .video-wrap').on('enter', el => {
			startVideo(el);
		}).on('exit', el => {
			stopVideo(el);
		});


	var flexplayer = null;
	var stopVideo = function ( element ) {
		var iframe = element.querySelector( 'iframe');
		var video = element.querySelector( 'video' );
		if ( iframe ) {
			var iframeSrc = iframe.src;
			flexplayer = new Vimeo.Player(iframe);
			flexplayer.pause();
		}
		if ( video ) {
			video.pause();
		}
	};
	var startVideo = function ( element ) {
		var iframe = element.querySelector( 'iframe');
		var video = element.querySelector( 'video' );
		if ( iframe ) {
			var iframeSrc = iframe.src;
			flexplayer = new Vimeo.Player(iframe);
			flexplayer.play();
		}
		if ( video ) {
			video.play();
		}
	};